import React, { memo, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import dynamic from 'next/dynamic';
import { Icon } from '../../../Icon';
import LogoIcon from '../../../../public/static/images/item/logo.svg';
import ShareIcon from '../../../../public/static/images/item/share.svg';
import {
  setAdriverSelectedCity,
  setChosenLocationNames,
  setCurrentState,
  setLocationIds,
  switchTab
} from '../../../../actions';
import { Bookmark } from '../../../Bookmark';
import { Cities } from '../../../../utils/helpers/constants';
import {
  ActionWrapper,
  BookmarkWrapper,
  Header,
  HeaderContentWrapper,
  LeftAction,
  Logo,
  RightAction
} from './styled';

interface CurrentItemHeaderProps {
  isBookmarked: boolean;
  setFavorited: React.Dispatch<React.SetStateAction<boolean>>;
  logoDataStat: string;
  isBookmarkVisible: boolean;
  isShareVisible: boolean;
}

const BackButton = dynamic(
  () => import('../../../BackButton').then(mod => mod.BackButton),
  { ssr: false }
);

export const CurrentItemHeader: React.FC<CurrentItemHeaderProps> = memo(
  ({
    isBookmarkVisible,
    isBookmarked,
    setFavorited,
    logoDataStat,
    isShareVisible
  }) => {
    const [showShareButton, setShowShareButton] = useState(false);

    const router = useRouter();
    const dispatch = useDispatch();
    const { id } = router.query;

    const onLogoClickHandler = () => {
      dispatch(switchTab(0));
      dispatch(setLocationIds([]));
      dispatch(setChosenLocationNames([]));
      dispatch(setCurrentState(null));
      dispatch(setAdriverSelectedCity(Cities.Baku.az));

      return router.push('/');
    };

    const onShareClickHandler = async () => {
      try {
        await window.navigator.share({
          url: window.location.href
        });
      } catch (e) {
        if (String(e).includes('AbortError')) {
          console.log('share operation was aborted');
        }
      }
    };

    useEffect(() => {
      if ('share' in window.navigator) {
        setShowShareButton(true);
      }
    }, []);

    return (
      <Header data-cy="current-item-header">
        <HeaderContentWrapper>
          <LeftAction>
            <BackButton />
          </LeftAction>

          <Logo
            data-cy="white-header-logo"
            onClick={onLogoClickHandler}
            onKeyPress={onLogoClickHandler}
            role="button"
            tabIndex={-1}
            data-stat={logoDataStat}
            aria-label="Logo"
          >
            <Icon
              indent={false}
              IconComponent={LogoIcon}
              width={79}
              height={18}
            />
          </Logo>

          {(isBookmarkVisible || isShareVisible) && (
            <RightAction>
              {isShareVisible && showShareButton && (
                <ActionWrapper
                  role="button"
                  tabIndex={-1}
                  onKeyPress={onShareClickHandler}
                  onClick={onShareClickHandler}
                >
                  <Icon
                    indent={false}
                    IconComponent={ShareIcon}
                    width={35}
                    height={35}
                  />
                </ActionWrapper>
              )}
              {isBookmarkVisible && (
                <BookmarkWrapper $isFavorited={isBookmarked}>
                  <Bookmark
                    itemId={(Array.isArray(id) ? id[0] : id) || ''}
                    isActive={isBookmarked}
                    setFavorited={setFavorited}
                    renderCurrentIcons
                    isGalleryHeader
                  />
                </BookmarkWrapper>
              )}
            </RightAction>
          )}
        </HeaderContentWrapper>
      </Header>
    );
  }
);

CurrentItemHeader.displayName = `CurrentItemHeader`;
